<template>
	<div class="sxzxList">
    <div class="top_title wow fadeInUp" data-wow-delay="0.2s">
      <div class="top_text">
        <p>实训中心</p>
        <span>TRAINING CENTER</span>
      </div>
    </div>
    <div class="sxzxswiperList"  :style="{position: 'relative',height: styles.height+'px'}" >
      <div class="swiper-container" :style="{width: styles.width+'px', position: 'absolute',height: styles.height+'px',left: '50%',marginLeft: '-960px'}">
        <div class="swiper-wrapper">
            <div v-for="(item, index) in sxzxList" :key="index"    class="swiper-slide" >
              <router-link :to="item.Url" :href="item.Url"  @click.native="OpenLink(item.Url)"   ><img :src="item.FileUrl"   /></router-link>
            </div>
        </div>
      <!-- 如果需要分页器 -->
        <div class="swiper-pagination"></div>

      <!-- 如果需要导航按钮 -->
      <!-- <div  v-if="sxzxList.length>1" class="swiper-button-prev" style="left: 50%; margin-left: -620px"></div>
      <div  v-if="sxzxList.length>1" class="swiper-button-next" style="left: 50%; margin-left: 600px"></div> -->

      <!-- 如果需要滚动条 -->
      <!-- <div class="swiper-scrollbar"></div> -->
      </div>
    </div>
	</div>
</template>

<script>
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';

// import 'swiper/css/swiper.min.css';
export default {
  name: 'sxzxSlider',
  props: {
   sxzxList: { // 图片列表 src数组
      type: Array,
      default: () => []
    },
    isShowPosition: { // 是否显示下方小圆点
      type: Boolean,
      default: true
    },
    isShowLeftOrRightBtn: { // 是否显示左右按钮
      type: Boolean,
      default: true
    },
    duration: { // 切换间隔
      type: [Number, String],
      default: 5000
    },
    animationT: {
     type: Object,
     default: () => {
        return {
          speed: 20,
          speedTime: 20
        }
      }
    },
    styles: { // 自定义轮播图片宽高 默认500*300
      type: Object,
      default: () => {
        return {
          width: 1920,
          height: 310
        }
      }
    }
  },
  data () {
    return {
      active: 1, // 当前轮播图片
      timer: null,// 定时器
      len: 1,
      screenWidthtimer: false,
      screenWidth: document.body.clientWidth, // 屏幕宽度
    }
  },
   mounted () {
    if(this.sxzxList.length>1){
      var mySwiper3 = new Swiper ('.sxzxswiperList .swiper-container', {
        // autoplay: {
        //         disableOnInteraction: false,
        //         delay:3000,
        //     },
          slidesPerView: 5,
          centeredSlides: true,
          paginationClickable: true,
          spaceBetween: 3,
          loop: true,
          // 如果需要分页器
          pagination: '.sxzxswiperList .swiper-pagination',
          // 如果需要前进后退按钮
      
          // nextButton: '.sxzxswiperList .swiper-button-next',
          // prevButton: '.sxzxswiperList .swiper-button-prev',
      })
    } 
    
  },

}
</script>

<style lang="less">
.sxzxList{
  // width: 1920px;
  height: 380px;
  min-width: 1200px;
  max-width: 1920px;
  overflow: hidden;
  margin-bottom: 50px;
  box-sizing: border-box;
}
.sxzxList .sxzxswiperList{
  // width: 1920px;
  height: 310px;
  overflow: hidden;
  margin: 0 auto;
}
.sxzxList .swiper-container{
  width: 100%;
  height: 310px;
}
.sxzxList .swiper-wrapper{
  width: 100%;
  height: 264px;
}
.sxzxList .swiper-slide{
  // width: 382px !important;
  height: 264px;
  margin: 0;
  position: relative;
}
.sxzxList .swiper-slide a{
  display: block;
  width: 382px;
  height: 100%;
  margin: 0;
}
.sxzxList .swiper-slide a img{
  display: block;
  width: 382px;
  height: 100%;
}
.sxzxList .swiper-pagination.swiper-pagination-bullets{
  font-size: 0 !important;
  bottom: 10px !important;
}
.sxzxList .swiper-pagination-bullet{
  width: 10px !important;
  height: 10px !important;
  background-color: #C4C4C4 !important;
  border-radius: 50% !important;
  opacity: 1 !important;
}
.sxzxList .swiper-pagination-bullet.swiper-pagination-bullet-active{
  width: 10px !important;
  height: 10px !important;
  background-color: #0376BE !important;
  border-radius: 50% !important;
  opacity: 1 !important;
  transition: all .3s !important;
}
</style>



// WEBPACK FOOTER //
// src/components/sxzxSlider.vue